
<component
  :is="as"
  class="index-category-card"
  v-bind="$attrs"
  v-on="$listeners"
>
  <align small-gap>
    <icon :class="['category-icon', { success: highlight }]" :name="icon" />

    <h6 class="secondary-font">{{ text }}</h6>
  </align>

  <align
    v-if="percentChange !== null"
    class="trending"
    :class="{ success: percentChange > 0, error: percentChange < 0 }"
    small-gap
  >
    <span>{{ percentChange > 0 ? '+' : '' }}{{ $filters.percentage(percentChange) }}</span>
    <icon :name="percentChange > 0 ? 'trending_up' : 'trending_down'" />
  </align>
</component>
